import moment from "moment";

/**
 * Vigencia de los eventos de "Qué plan hoy" (colección `queplanhoy`).
 *
 * La app escribe las fechas como texto "DD-MM-YYYY" y las horas como texto
 * libre "HH:MM" que teclea el usuario (ver recnet-24 CrearQuePlanHoy), así que
 * hay que ser tolerante al interpretarlas.
 */

const FORMATOS_FECHA = ["DD-MM-YYYY", "DD/MM/YYYY", "YYYY-MM-DD", moment.ISO_8601];
const FORMATOS_HORA = ["HH:mm", "H:mm", "HH:mm:ss", "hh:mm A", "h:mm A"];

function parseFecha(valor) {
  if (!valor) return null;
  if (typeof valor.toDate === "function") return moment(valor.toDate());
  const m = moment(String(valor).trim(), FORMATOS_FECHA, true);
  return m.isValid() ? m : null;
}

function parseHora(valor) {
  if (!valor) return null;
  const m = moment(String(valor).trim(), FORMATOS_HORA, true);
  return m.isValid() ? { horas: m.hours(), minutos: m.minutes() } : null;
}

/**
 * Momento en que el evento deja de estar vigente.
 *
 * Se toma la fecha de fin y, si no hay, la de inicio (un evento de un solo día
 * no captura fechaFin). Sin hora válida se asume que dura hasta el final del
 * día: dar por terminado a medianoche un evento de las 20:00 lo apagaría el
 * mismo día que ocurre.
 */
export function vencimientoDe(evento) {
  if (!evento) return null;

  const fecha = parseFecha(evento.fechaFin) || parseFecha(evento.fechaInicio);
  if (!fecha) return null;

  const hora = parseHora(evento.horaFin) || (evento.fechaFin ? null : parseHora(evento.horaInicio));
  if (!hora) return fecha.clone().endOf("day");

  return fecha.clone().hour(hora.horas).minute(hora.minutos).second(0);
}

/** True si la fecha y hora de término ya pasaron. */
export function estaVencido(evento) {
  const vence = vencimientoDe(evento);
  return !!vence && vence.isBefore(moment());
}

/**
 * Los eventos creados desde la app no traen el campo `activo` — sólo lo
 * escribe este panel. Un evento sin el campo está publicado, así que la
 * ausencia se interpreta como activo.
 */
export function estaActivo(evento) {
  return !!evento && evento.activo !== false;
}

/** Estado mostrado en la tabla, ya combinando vigencia y bandera manual. */
export function estadoDe(evento) {
  if (estaVencido(evento)) {
    return { clave: "vencido", texto: "Vencido", variante: "danger", filaVariante: "table-danger" };
  }
  if (!estaActivo(evento)) {
    return { clave: "inactivo", texto: "Inactivo", variante: "secondary", filaVariante: "table-warning" };
  }
  return { clave: "activo", texto: "Activo", variante: "success", filaVariante: "table-success" };
}

export function vencimientoTexto(evento) {
  const vence = vencimientoDe(evento);
  return vence ? vence.format("DD/MM/YYYY HH:mm") : "Sin fecha";
}

/** Eventos que ya vencieron pero siguen marcados como activos. */
export function eventosPorCerrar(eventos) {
  return eventos.filter((e) => estaVencido(e) && estaActivo(e));
}
